import { useState } from "react"
import { StandardButton } from "../atoms/buttons"
import { InputForm } from "../atoms/input"
import { Modal, ModalBody, ModalFooter, ModalTitle } from "./modal"
import { Alert } from "./alert"
import { postAPI } from "../api/api"

export const LeadPopOver = ({ visible, dismissable,count,chosenCourses}) => {
    
    
    const [concluded, setConcluded] = useState(false)

    const handleDemo = async  () => {
            const courses = {"courses":chosenCourses}
            await postAPI('teaser/teaser-info', courses)
            setConcluded(!concluded)
            return 
        
        
    }
    return (
        !concluded?
        <Modal
            visible={visible}
            dismissable={dismissable}

        >
            <ModalTitle
                hasXmark={true}
                dismissable={dismissable}
                title={`Je hebt ${count} e-learnings geselecteerd!`}
            />
            <ModalBody>
                <p className="standard-text">Hartelijk dank voor je interesse! Zodra je de aanvraag hebt verstuurd, gaan wij direct aan de slag met het afronden van de e-learnings.</p>

            </ModalBody>
            <ModalFooter style={{
                borderColor: "rgb(224, 224, 224)",
                paddingTop: "1rem",
                borderTopWidth: "0.5px",
                borderTopStyle: "solid"
            }}>             
            

                <StandardButton
                onClick={handleDemo}
                title={"Verstuur aanvraag!"}></StandardButton>

            </ModalFooter>
        </Modal>
        :<FinishedModal/>
    )
}



const FinishedModal = () => {
    return(
        <Modal visible={true}>
            <ModalTitle title={"Bedankt voor je aanvraag!"}></ModalTitle>
            <ModalBody>
                
            </ModalBody>
            <ModalFooter>
                <StandardButton
                    onClick={() => window.location.href = "https://expligo.nl"}
                    title={"Terug naar expligo"}
                />
            </ModalFooter>
        </Modal>
    )
}